var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.contentData
    ? _c(
        "div",
        { ref: "carousel", class: ["carousel carousel--homepage"] },
        [
          _c("div", { staticClass: "carousel__absolute" }, [
            _c(
              "div",
              {
                ref: "background",
                class: [
                  "carousel__background",
                  { "carousel__background--sticky": !_vm.isIE }
                ]
              },
              [
                _vm._l(_vm.screens, function(key, keyIndex) {
                  var _obj, _obj$1
                  return [
                    typeof _vm.contentData.bgs[keyIndex] === "string"
                      ? _c("div", {
                          class:
                            ((_obj = {}),
                            (_obj[
                              "carousel__background-item carousel__background--" +
                                key
                            ] = true),
                            (_obj["carousel__background--" + key + "-active"] =
                              _vm.currentSlide === keyIndex),
                            _obj)
                        })
                      : _c(
                          "div",
                          {
                            class:
                              ((_obj$1 = {}),
                              (_obj$1[
                                "carousel__background-item carousel__background--" +
                                  key
                              ] = true),
                              (_obj$1[
                                "carousel__background--" + key + "-active"
                              ] = _vm.currentSlide === keyIndex),
                              _obj$1)
                          },
                          [
                            _c("v-image", {
                              attrs: {
                                alt: "Todo fill alt",
                                "aspect-ratio": false,
                                tiny: _vm.getImage(
                                  0,
                                  _vm.contentData.bgs[keyIndex].image
                                )
                              }
                            })
                          ],
                          1
                        )
                  ]
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c(
            "v-row",
            { staticClass: "carousel__row", attrs: { varaint: "flex" } },
            [
              _c("v-column", { attrs: { large: 12 } }, [
                _c("div", { staticClass: "carousel__wrapper" }, [
                  _c("div", { ref: "sticky", staticClass: "carousel__left" }, [
                    _c(
                      "div",
                      {
                        class: [
                          "carousel__sticky",
                          { "carousel__sticky--active": !_vm.isIE }
                        ]
                      },
                      [
                        _c("div", { staticClass: "carousel__sticky-wrapper" }, [
                          _c(
                            "div",
                            {
                              ref: "animationWrapper",
                              staticClass: "carousel__image-wrapper"
                            },
                            [
                              _c(
                                "div",
                                {
                                  ref: "phone",
                                  staticClass:
                                    "carousel__visual carousel__visual--svg"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "carousel__visual-cards" },
                                    [
                                      !_vm.isMobile
                                        ? _c("v-animated-cards", {
                                            attrs: {
                                              name: _vm.contentData.cards[0]
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "carousel__visual-svg" },
                                    [
                                      _c("v-icon", {
                                        staticClass:
                                          "carousel__visual-svg--card",
                                        attrs: {
                                          name: "symbols/letters/a-blue"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            viewBox: "0 0 251 500",
                                            width: "251px",
                                            xmlns: "http://www.w3.org/2000/svg"
                                          }
                                        },
                                        [
                                          _c("use", {
                                            attrs: { "xlink:href": "#ui/mock" }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "carousel__visual-image-wrapper"
                                        },
                                        _vm._l(_vm.screens, function(
                                          key,
                                          keyIndex
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key:
                                                "carousel__visual-image--" +
                                                keyIndex,
                                              ref: "carouselSlideImage",
                                              refInFor: true,
                                              staticClass:
                                                "carousel__visual-image"
                                            },
                                            [
                                              _c("v-image", {
                                                attrs: {
                                                  alt:
                                                    _vm.contentDataScreens[key]
                                                      .image.desktop.alt,
                                                  "aspect-ratio": 219 / 472,
                                                  tiny: _vm.getImage(
                                                    1,
                                                    _vm.contentDataScreens[key]
                                                      .image.desktop.default
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        }),
                                        0
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "carousel__right" }, [
                    _c(
                      "div",
                      { staticClass: "carousel__item" },
                      _vm._l(_vm.screens, function(key, keyIndex) {
                        return _c(
                          "div",
                          {
                            key: "carousel__content-" + key + "--" + keyIndex,
                            ref: "content",
                            refInFor: true,
                            class: [
                              "carousel__content",
                              "carousel__content--" + key,
                              typeof _vm.contentData.bgs[keyIndex] !== "string"
                                ? "carousel__content--" +
                                  _vm.contentData.bgs[keyIndex].image
                                : null
                            ]
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "carousel__content-inner" },
                              [
                                _c(
                                  "div",
                                  {
                                    ref: "carouselContentHead",
                                    refInFor: true,
                                    staticClass: "carousel__content-head"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        ref: "contentTrigger",
                                        refInFor: true,
                                        staticClass:
                                          "carousel__headline-wrapper"
                                      },
                                      [
                                        _c("v-typo", {
                                          staticClass: "carousel__headline",
                                          attrs: { variant: "h2" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.contentDataScreens[key]
                                                .headline
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-typo", {
                                      staticClass: "carousel__paragraph",
                                      attrs: { variant: "body-paragraph" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.contentDataScreens[key].paragraph
                                        )
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    ref: "carouselContentImage",
                                    refInFor: true,
                                    staticClass: "carousel__content-image"
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "carousel__content-image-background"
                                    }),
                                    _vm._v(" "),
                                    _vm.isMobile
                                      ? _c("v-animated-cards", {
                                          attrs: {
                                            name:
                                              _vm.contentData.cards[keyIndex]
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("v-image", {
                                      attrs: {
                                        alt:
                                          _vm.contentDataScreens[key].image
                                            .mobile.alt,
                                        "aspect-ratio": 177 / 350,
                                        tiny: _vm.getImage(
                                          2,
                                          _vm.contentDataScreens[key].image
                                            .mobile.default
                                        )
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.contentDataScreens[key] && !_vm.isMobile
                                  ? _c("v-accordion-group", {
                                      staticClass: "carousel__content-toggle",
                                      attrs: {
                                        data: _vm.contentDataScreens[key],
                                        "is-headline": false,
                                        toggle: _vm.currentSlide === keyIndex,
                                        name: key
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    ref: "carouselBenefits",
                                    refInFor: true,
                                    staticClass: "carousel__benefits"
                                  },
                                  _vm._l(
                                    _vm.contentDataScreens[key].items,
                                    function(item, itemIndex) {
                                      return _c(
                                        "div",
                                        {
                                          key: "love-slider--" + itemIndex,
                                          staticClass: "carousel__benefit"
                                        },
                                        [
                                          _c("v-typo", {
                                            staticClass:
                                              "carousel__benefit-title",
                                            attrs: { variant: "h4" },
                                            domProps: {
                                              innerHTML: _vm._s(item.title)
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm._l(item.content, function(
                                            paragraph
                                          ) {
                                            return _c("v-typo", {
                                              key:
                                                "mobile-slider-" +
                                                _vm.contentDataScreens[key] +
                                                "--paragraph",
                                              staticClass:
                                                "carousel__benefit-paragraph",
                                              attrs: {
                                                variant: "body-paragraph"
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(paragraph)
                                              }
                                            })
                                          })
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(" "),
                                _vm.contentDataScreens[key].button
                                  ? _c(
                                      "v-button",
                                      {
                                        staticClass: "carousel__content-action",
                                        attrs: {
                                          to: {
                                            path: _vm.path(
                                              _vm.contentDataScreens[key].button
                                                .to
                                            )
                                          },
                                          variant:
                                            _vm.contentDataScreens[key].button
                                              .variant
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.$root.$emit(
                                              "trackToGTM",
                                              [
                                                "btnClick",
                                                _vm.contentDataScreens[key]
                                                  .button.type
                                              ]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.contentDataScreens[key].button
                                                .label
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }